import createStringFacet from '../createStringFacet';

export default createStringFacet({
  stateKey: 'regionNames',
  itemKey: 'regionName',
  sortBy: 'value',
  sortDirection: 'asc',
});
